<script setup lang="ts">
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';
    import { InvoiceDocumentType } from '@/app/invoicing/enums/InvoiceDocumentType';

    interface Props extends FormInputProps {
        withCreateButton?: boolean;
        documentType: InvoiceDocumentType;
    }

    const select = ref(null);
    const props = withDefaults(defineProps<Props>(), {
        withCreateButton: false,
        documentType: 'quote',
    });
    const inputData: FormInputData = useFormInput(props);
    const displayCreateButton = computed(() => props.withCreateButton && !inputData?.model.value);
</script>

<template>
    <FormElement
        :input-data="inputData"
        @label-clicked="select?.show()"
    >
        <SelectQuote
            ref="select"
            :initial-value="inputData.model"
            :with-create-button="displayCreateButton"
            :document-type="documentType"
        >
            <template
                v-if="inputData.model.value"
                #button
            >
                <div class="flex items-center h-full space-x-3">
                    <a
                        href="#"
                        class="text-sm text-gray-600 transition-all cursor-pointer hover:text-primary"
                        :data-tooltip="$t('actions.unselect')"
                        :data-tooltip-location="'left'"
                        @click.stop.prevent="inputData.model.value = null"
                    >
                        <i class="fa-regular fa-xmark" />
                    </a>
                </div>
            </template>
        </SelectQuote>
    </FormElement>
</template>
